import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import { Grid, makeStyles } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import { Link } from 'react-router-dom';
import { GoogleLogout } from 'react-google-login';
import routes from '../../Utils/routes.json';
import { Box } from '@material-ui/core';
import clsx from 'clsx';

const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  appBar: {
    // zIndex: theme.zIndex.drawer + 1,
    background: theme.palette.KenColors.sideNavItemHoverColor,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    background: theme.palette.KenColors.sideNavItemHoverColor,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  plainLink: {
    textDecoration: 'none',
    cursor: 'pointer',
    color: theme.palette.KenColors.kenWhite,
  },
  logoWrap: {
    width: 60,
    height: 60,
  },
  toolbar: {
    paddingLeft: 8,
  },
  logoWithTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  labelOpen: {
    marginLeft: 30,
    color: theme.palette.KenColors.KenBlack,
  },
  labelClose: {
    marginLeft: 78,
    color: theme.palette.KenColors.KenBlack,
  },
}));

export default function ElevateAppBar(props) {
  const {
    title,
    handleClick,
    style,
    logo,
    titleStyle,
    history,
    openDrawer,
    setOpenDrawer,
  } = props;
  // const history = useHistory();
  const classes = useStyles();

  const onLogoutSuccess = () => {
    // console.log('logged out...! history', history);
    localStorage.clear();
    history.replace(`${routes.login}`);
  };

  const onFailure = () => {
    console.log('logout fail');
  };

  return (
    <React.Fragment>
      <CssBaseline />
      {/* <ElevationScroll {...props}> */}
      <AppBar
        data-testid="header"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: openDrawer,
        })}
        style={style}
        elevation={0}
      >
        <Toolbar className={classes.toolbar}>
          <Grid container spacing={1} alignItems="center">
            <Grid item md={10} xs={9} className={classes.logoWithTitle}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleClick}
                className={classes.menuButton}
              >
                <MenuIcon />
              </IconButton>

              {/* {logo && (
                  <Box component="span">
                    <img
                      src={logo}
                      alt="logo"
                      className={classes.logoWrap}
                    ></img>
                  </Box>
                )} */}

              <Link to="/dashboard" className={classes.plainLink}>
                <Typography
                  variant="h6"
                  style={titleStyle}
                  className={clsx({
                    [classes.labelOpen]: openDrawer,
                    [classes.labelClose]: !openDrawer,
                  })}
                >
                  {title}
                </Typography>
              </Link>
            </Grid>
            <Grid item md={2} style={{ textAlign: '-webkit-right' }}>
              <GoogleLogout
                clientId="819877897170-4qe53rpg56n11l6i7oqusda9djec3huv.apps.googleusercontent.com"
                buttonText="Logout"
                onLogoutSuccess={onLogoutSuccess}
                onFailure={onFailure}
                icon={false}
                // render={(renderProps) => (
                //   <Avatar alt="avatar" onClick={signOut}></Avatar>
                // )}
              ></GoogleLogout>
              {/* <Avatar alt="avatar" onClick={signOut}></Avatar> */}
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      {/* </ElevationScroll> */}
      {/* <Toolbar /> */}
    </React.Fragment>
  );
}
